import React, { useState, useEffect } from 'react';
import classes from './../TrialstatNoto.module.css';
import { Button, Row, Col } from 'react-bootstrap';
import InputContainer from '../UI/Container/InputContainer';
import InputString from '../UI/Control/InputString';
import TextArea from '../UI/Control/InputTextarea';
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import InputCheckbox from '../UI/Control/InputCheckbox';

const ReAssignRead = (props) => {
    const [arrReAssignRead, setArrReAssignRead] = useState({});

    const fetchReAssignListReadersByTaskID = () => {
        fetch('api/ImageService/GetReAssignListReadersByTaskID?taskId=' + props.taskId)
            .then(response => response.json())
            .then(data => {
                setArrReAssignRead(data);
            });
    }
    useEffect(() => {
        fetchReAssignListReadersByTaskID();
    }, []);

    const SaveReAssignRead = (event) => {

        let objNotes = document.getElementById('txtNotes');
        if (objNotes.value.trim() == '') {
            alert('Notes should not be empty.');
            objNotes.focus();
            return false;
        }

        let model = {
            TaskID: props.taskId,
            listReAssignModel: new Array(),
            Notes: objNotes.value,
        };

        let objReAssign = document.getElementsByName('chkReAssign');
        let edcUserId = 0;
        let reAssign = 'N';
        for (var cnt = 0; cnt < objReAssign.length; cnt++) {
            let id = objReAssign[cnt].id;
            let edcUserId = document.getElementById('hdnEDCUserId_' + cnt).value; 
            let reAssign = document.getElementById('chkReAssign_' + cnt).checked ? 'Y' : 'N';
            if (reAssign == 'Y') {
                model.listReAssignModel.push({ EDCUserId: edcUserId, ReAssign: reAssign });
            }
        }

        fetch('api/ImageService/SaveReAssignRead', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(model)
        }).then(r => r.json()).then(res => {
            if (res == -1) {
                alert('ReAssign read not saved, Something went wrong.');
            }
            if (res > 0) {
                props.relaodAction();
            }
        })

    };

    return (
        <div>
            {
               arrReAssignRead != null && <Row id="rowQueryDetails">
                    <Col md={12} >
                        <InputContainer Expended='false' header="ReAssign Reader" style={{ textAlign: "center", marginTop: "15px" }}>
                            <Row style={{ marginLeft: "5px" }}>
                                <Col md={5} className={classes.cellRightBorder}><b>Reader</b></Col>
                                <Col md={5} className={classes.cellRightBorder}><b>Reader Type</b></Col>
                                <Col md={2} className={classes.cellRightBorder}><b>ReAssign</b></Col>
                            </Row>
                            {arrReAssignRead.length > 0 && arrReAssignRead.map((item, index) =>
                                <Row className key={index} style={{ marginLeft: "5px" }}>
                                    <input type="hidden" id={"hdnEDCUserId_" + index} value={item.EDCUserID} />
                                    <Col md={5} className={classes.cellRLBBorder}>{item.Reader}</Col>
                                    <Col md={5} className={classes.cellRightBorder}>{item.ReaderType}</Col>
                                    <Col md={2} className={classes.cellRightBorder}>
                                            <InputCheckbox id={"chkReAssign_" + index} name="chkReAssign" style={{ marginTop: "10px" }} ></InputCheckbox>
                                    </Col>
                                </Row>
                            )}
                        </InputContainer>
                    </Col>
                </Row>
            }

            <Row className="mt-2 mb-2">
                <Col md={1} style={{ marginLeft: "5px" }}>Notes<MandatoryLabel></MandatoryLabel>: </Col>
                <Col md={9}>
                    <TextArea id="txtNotes" rows='5' cols='100' />
                </Col>
                <Col md={1}><Button style={{ marginTop: "90px" }} className="btn-success" onClick={SaveReAssignRead} > Submit </Button></Col>
            </Row>
        </div>
    );
};

export default ReAssignRead;
